import script from "./UserHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./UserHeader.vue?vue&type=script&setup=true&lang=js"

import "./UserHeader.vue?vue&type=style&index=0&id=2f150f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f150f58"]])

export default __exports__